module.exports = __webpack_public_path__ + "static/media/p2pimg.caacbfb2.png";